<template>
  <kst-container class="kst-Delivery-details">
    <kst-form 
      :loading="isLoading" 
      :title="title"
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>

      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../DeliveryInfo.js";
import Model from "../DeliveryModel.js";

import Action from "./DeliveryDetails_Action";
import Details from "./DeliveryDetails_Details";
import Items from "./DeliveryDetails_Items";

import Services from "../DeliveryServices.js";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    Items
  },
  data: () => ({
    data: {},
    isLoading: true,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    },
    // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};
      this.initLoad(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    loadDetails(id) {
      const config = Services.getDeliveryDetails(id);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      this.data = data;
      Model.setDetailsByStatus(this.data);

      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }

      this.loadDetails_SO(data.SOID);
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },

    loadDetails_SO(id) {
      const config = Services.getInvoiceDetails(id);
      this.runAxios(config, null, this.loadDetails_SO_Success, this.loadDetails_SO_Error);
    },
    loadDetails_SO_Success(data) {
      Model.updateDetailsBySO(this.data, data);
      this.initLoad_End();
    },
    loadDetails_SO_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }

  }
}
</script>